import { render } from "./UnRegisterTournamentDialog.vue?vue&type=template&id=333dbf7a"
import script from "./UnRegisterTournamentDialog.vue?vue&type=script&lang=js"
export * from "./UnRegisterTournamentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__